"use client";
import { ElementType } from "@/constants/tagular/main";
import { ElementClicked } from "@/hooks/eventing/types/redventures.usertracking.v3.ElementClicked";
import useElementEvents from "@/hooks/eventing/useElementEvents";

interface LinkBlocksColumnsProps {
  numberOfColumns: number;
  column: {
    props: {
      subtitle: React.ReactNode;
      children?: React.ReactNode;
    };
  };
}

export const LinkBlocksColumns = ({
  numberOfColumns,
  column,
}: LinkBlocksColumnsProps) => {
  const { props } = column;
  const { subtitle, children } = props;
  const childrenArray = Array.isArray(children) ? children : [children];

  const baseWebElement: ElementClicked["webElement"] = {
    elementType: ElementType.Link,
    location: "link-blocks-columns",
  };

  const { elementClicked: triggerElementClick } = useElementEvents({
    webElement: baseWebElement,
  });

  const handleElementClick = (text: string, href: string, index: number) => {
    const itemWebElement: ElementClicked["webElement"] = {
      elementType: ElementType.Link,
      htmlId: `link-element-${index}`,
      location: "link-blocks-columns",
      position: `${index + 1}`,
      text: text,
    };

    triggerElementClick({
      webElement: itemWebElement,
      outboundUrl: href,
    });
  };

  const getColumnClass = () => {
    let columnClass = "";
    const baseColumnClass = "w-full";
    switch (numberOfColumns) {
      case 1:
        columnClass = "";
        break;
      case 2:
        columnClass = "md:w-[calc(50%-0.5rem)]";
        break;
      case 3:
        columnClass = "md:w-[calc(33.333%-0.667rem)]";
        break;
      default:
        columnClass = "";
    }

    return `${baseColumnClass} ${columnClass}`;
  };

  return (
    <div className={getColumnClass()}>
      <div className="text-gray-700 text-base font-bold">{subtitle}</div>
      <div className="flex flex-col gap-2">
        {childrenArray.map((linkElement, i) => {
          const { props } = linkElement;
          const { text, href } = props;
          return (
            <a
              id={`link-element-${i}`}
              key={`${href}-${i}`}
              href={href}
              className="block text-gray-700 font-normal text-base"
              onClick={() => handleElementClick(text, href, i)}
            >
              {text}
            </a>
          );
        })}
      </div>
    </div>
  );
};
